var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupportCollapseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0004 10.8054C17.0004 10.4594 17.0004 10.2864 17.0524 10.1324C17.2034 9.68437 17.6024 9.51137 18.0024 9.32937C18.4504 9.12437 18.6744 9.02237 18.8974 9.00437C19.1494 8.98437 19.4024 9.03837 19.6184 9.15937C19.9044 9.31937 20.1044 9.62537 20.3084 9.87337C21.2514 11.0194 21.7234 11.5924 21.8954 12.2234C22.0354 12.7334 22.0354 13.2674 21.8954 13.7764C21.6444 14.6984 20.8494 15.4704 20.2604 16.1864C19.9594 16.5514 19.8084 16.7344 19.6184 16.8414C19.3987 16.9632 19.1478 17.0172 18.8974 16.9964C18.6744 16.9784 18.4504 16.8764 18.0014 16.6714C17.6014 16.4894 17.2034 16.3164 17.0524 15.8684C17.0004 15.7144 17.0004 15.5414 17.0004 15.1954V10.8054ZM7.0004 10.8054C7.0004 10.3694 6.9884 9.97837 6.6364 9.67237C6.5084 9.56137 6.3384 9.48437 5.9994 9.32937C5.5504 9.12537 5.3264 9.02237 5.1034 9.00437C4.4364 8.95037 4.0774 9.40637 3.6934 9.87437C2.7494 11.0194 2.2774 11.5924 2.1044 12.2244C1.9652 12.7327 1.9652 13.2691 2.1044 13.7774C2.3564 14.6984 3.1524 15.4714 3.7404 16.1864C4.1114 16.6364 4.4664 17.0474 5.1034 16.9964C5.3264 16.9784 5.5504 16.8764 5.9994 16.6714C6.3394 16.5174 6.5084 16.4394 6.6364 16.3284C6.9884 16.0224 7.0004 15.6314 7.0004 15.1964V10.8054Z",
    stroke: "#435B37",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 9C5 5.686 8.134 3 12 3C15.866 3 19 5.686 19 9M19 17V17.8C19 19.567 17.21 21 15 21H13",
    stroke: "#435B37",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportCollapseIcon);
export default __webpack_public_path__ + "static/media/SupportCollapseIcon.dfdf1c2cba67cdcda31841908086c4c6.svg";
export { ForwardRef as ReactComponent };